export default __webpack_public_path__ + "static/img4-f2f885f9a5ce4cc1e8bfc0ce67f5f090.png";